export default __webpack_public_path__ + "static/media/Sadar-Manzil.1bfae8a8.jpg";